"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var supportedColors = ['dart', 'charcoal', 'silver', 'orange', 'purple', 'pink', 'teal', 'indigo', 'red', 'yellow', 'green', 'blue'];
var BackgroundColorClasses = {};
supportedColors.forEach(function (c) {
  BackgroundColorClasses[c] = "bg-".concat(c);
  BackgroundColorClasses["".concat(c, "-lighter")] = "bg-".concat(c, "-lighter");
  BackgroundColorClasses["".concat(c, "-light")] = "bg-".concat(c, "-light");
  BackgroundColorClasses["".concat(c, "-dark")] = "bg-".concat(c, "-dark");
});
var _default = BackgroundColorClasses;
exports.default = _default;